import {Component, OnInit} from '@angular/core';

import {AuthRESTService} from "../../../services/rest/auth-rest.service";
import Commons from "../../commons";
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { SharedModule } from 'app/shared.module';
import { AppWidgetModule } from 'app/components/widgets/widget.module';

@Component({
    templateUrl: './user-create.component.html',
    standalone: true,
    imports: [SharedModule, AppWidgetModule]
})
export class UserCreatePage extends Commons implements OnInit {
    allRoles: Array<string> = [];
    allInsitutions: Array<any> = [];
    user: any = {};
    errorMessage = '';

    constructor(private rest: AuthRESTService, toastr: ToastrService, translate: TranslateService) {
        super(toastr, translate)
    }

    ngOnInit(): void {
        this.rest.get('roles').subscribe(response => {
            this.allRoles = response
        }, err => this.errorHandler(err));
        this.rest.get('institution/allFull').subscribe(response => {
            this.allInsitutions = response
        }, err => this.errorHandler(err));
    }

    save(): void {
        this.rest.put('profile', this.user).subscribe(() => {
                this.clearNotifications().addSuccess('general.saved');
                this.errorMessage = '';
            }, err => this.errorHandler(err)
        )
    }

}
